import { forwardRef, Ref } from 'react'
import {
  Route,
  RouteProps,
  LinkProps,
  Link,
  NavLink,
  NavLinkProps
} from 'react-router-dom'

import { isFaAvailableInLanguages } from '../helpers/userData'
import { lang } from '../localization'

// A single Route with a path array is important for callers that use Switch:
// Switch can select it directly, whereas a fragment of independent Routes
// allows every matching route to render.
export const localizedPaths = (
  path: RouteProps['path']
): RouteProps['path'] => {
  if (!path || typeof path !== 'string') {
    return path
  }

  const paths: string[] = [path, `/en${path}`]
  if (isFaAvailableInLanguages()) {
    paths.push(`/fa${path}`)
  }
  return paths
}

export const LocalizedRoute = ({ path, ...otherProps }: RouteProps) => (
  <Route {...otherProps} path={localizedPaths(path)} />
)

export const LocalizedLink = forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ to, ...otherProps }: LinkProps, ref: Ref<HTMLAnchorElement>) => (
    <Link ref={ref} {...otherProps} to={`/${lang}${to}`} />
  )
)

export const LocalizedNavLink = forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ to, ...otherProps }: NavLinkProps, ref) => (
    <NavLink {...otherProps} to={`/${lang}${to}`} />
  )
)
